import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { VaultPreviews } from './VaultPreviews';
import { pillars, volumes, volumeIncludes } from '../data/volumes';
export function Volumes() {
  return <section aria-label="What is inside the ebook" className="bg-transparent" data-id="element-225" data-mp="185q4pzhxajxj">
      <div className="mx-auto max-w-6xl px-5 py-12" style={{
      paddingTop: '19px',
      paddingBottom: "21px"
    }} data-id="element-226" data-mp="1c6a1h1yl3lj5">
        <div className="text-center" data-id="element-227" data-mp="1zvktnv1vc7lo">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-grape" data-id="element-228" data-mp="24u5v1xsuwxbp">
            🏥 THE NUTRITIONIST’S VAULT™ — BY SIGMA SMART™
          </p>
          <h2 className="mt-3 font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-229" data-mp="1qtlbv0j14zho">
            What Will You Find Inside?
          </h2>
          <p className="mt-2 text-base text-plum/60" data-id="element-230" data-mp="1vvam4dyfh94p">
            6 complete volumes · 120+ pages — Everything you need in one place.
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-231" data-mp="kfcd2a392n3h">
            {pillars.map(p => <span key={p} className="rounded-full border border-grape/25 bg-lilac-soft px-3 py-1 text-xs font-bold uppercase tracking-wide text-plum-soft" data-id="element-232" data-mp="3o7df9a1k10px">
                {p}
              </span>)}
          </div>
          <p className="mt-8 font-display text-lg font-black uppercase tracking-[0.18em] text-plum-soft" data-id="element-233" data-mp="21q7y7c5quwi">
            📚 The 6-Volume Method
          </p>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-234" data-mp="b14voz0xwrdb">
          {volumes.map((t, i) => <motion.article key={t.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 3 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="group rounded-2xl border border-grape/15 bg-white p-5 transition-colors duration-200 ease-out hover:border-grape/45" style={{
          paddingTop: "10px",
          paddingBottom: "8px"
        }} data-id="element-235" data-mp="62tpcy9usyzu" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-236" data-mp="wtziixvkumdm">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-lilac-soft font-display text-lg font-black text-grape" data-id="element-237" data-mp="wvkcomdzc3ay">
                  {String(t.n).padStart(2, '0')}
                </span>
                <h3 className="text-sm font-bold leading-tight text-plum" data-id="element-238" data-mp="1bin8momnm3w6">
                  <span aria-hidden="true" data-id="element-239" data-mp="1bjyfixbebrri">{t.emoji} </span>
                  {t.title}
                </h3>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-plum/65" data-id="element-240" data-mp="1kjbn1kfym69l">{t.desc}</p>
            </motion.article>)}
        </div>

        <VaultPreviews data-id="element-241" data-mp="1pi523hawa5bv" />

        <div className="mt-10 rounded-2xl border border-grape/25 bg-white p-6" data-id="element-242" data-mp="1pjpub09qlc6k">
          <p className="text-center font-display text-lg font-black text-grape" data-id="element-243" data-mp="1uggcbt53qhum">
            ✅ Every volume includes
          </p>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-244" data-mp="3rbm86gjdmy4i">
            {volumeIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-plum/75" data-id="element-245" data-mp="3qhn96wt4m6">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-246" data-mp="2dfb2sbs62lb7" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}